import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ThemeShell } from '../-theme/shell';

/**
 * Referência do tema — a vitrine do design system com os nossos tokens.
 *
 * Existe para provar que o tema está certo: toda tela daqui é montada só com componentes de
 * `shared/ui`. `/theme` é a página inicial com cards, lista simples e a referência de tokens;
 * `/theme/list` é a lista completa (o DataTable); `/theme/kanban` é o quadro com arrastar.
 *
 * Por ser referência de desenvolvimento, é a única árvore de rotas isenta da regra de i18n.
 * Nenhum dado real: os itens são fictícios.
 */
export const Route = createFileRoute('/theme')({
  component: ThemeLayout,
});

function ThemeLayout() {
  return (
    <ThemeShell>
      <Outlet />
    </ThemeShell>
  );
}
